import React from "react";
import cl from "./Header.module.css";
import { NavLink } from "react-router-dom";
import { useState } from "react";
import call from "../../image/phone.svg";
import basket from "../../image/bag.svg";

const Header = (props) => {
  const [mobileMenu, setMobileMenu] = useState(cl.mobile_header_links_hidden);
  const [mobileMenuIcon, setMobileMenuIcon] = useState(cl.mobile_menu_icon);
  const [mobileCloseIcon, setMobileCloseIcon] = useState(
    cl.mobile_close_icon_hidden
  );
  let onMenuClick = () => {
    setMobileMenu(cl.mobile_header_links);
    setMobileMenuIcon(cl.mobile_menu_icon_hidden);
    setMobileCloseIcon(cl.mobile_close_icon);
  };
  let onCloseClick = () => {
    setMobileMenu(cl.mobile_header_links_hidden);
    setMobileMenuIcon(cl.mobile_menu_icon);
    setMobileCloseIcon(cl.mobile_close_icon_hidden);
  };
  let onSearchChange = (e) => {
    let text = e.target.value;
    props.updateNewSearchText(text);
  };
  let onSearchClick = () => {
    console.log(props.productsPage.newSearchText);
  };

  return (
    <section className={cl.container}>
      <div className={cl.top_line}>
        <div className={cl.bottom_line}>
          <div className={cl.middle_line_logo}>
            <h1>{props.aboutData.shopName}</h1>
          </div>
          <div className={cl.bottom_line_links}>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/contacts"
            >
              Contacts
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/policy"
            >
              Policy
            </NavLink>
          </div>
          <div className={cl.bottom_line_links}>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to=""
            >
              Home
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/about"
            >
              About
            </NavLink>

            <NavLink
              className={(headerData) =>
                headerData.isActive ? cl.header_link_active : cl.header_link
              }
              to="/products"
            >
              Products
            </NavLink>
          </div>
        </div>

        <div className={cl.middle_line}>
          <div className={cl.search_bar}>
            <input
              type="text"
              value={props.productsPage.newSearchText}
              onChange={onSearchChange}
              placeholder="Search"
              style={{
                background: "transparent",
                border: "none",
              }}
            ></input>
            <NavLink to="search">
              <button className={cl.search_bar_button} onClick={onSearchClick}>
                <svg
                  className={cl.search_bar_button_svg}
                  height="50px"
                  viewBox="0 0 50 50"
                  width="50px"
                >
                  <rect fill="none" />
                  <circle
                    cx="21"
                    cy="20"
                    fill="none"
                    r="16"
                    stroke="var(--primary)"
                    strokeLinecap="round"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                  />
                  <line
                    fill="none"
                    stroke="var(--primary)"
                    strokeMiterlimit="10"
                    strokeWidth="4"
                    x1="32.229"
                    x2="45.5"
                    y1="32.229"
                    y2="45.5"
                  />
                </svg>
              </button>
            </NavLink>
          </div>

          <svg
            onClick={onCloseClick}
            className={mobileCloseIcon}
            height="24px"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 32 32"
            width="24px"
            fill="white"
          >
            <g>
              <polyline
                fill="none"
                points="   649,137.999 675,137.999 675,155.999 661,155.999  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <polyline
                fill="none"
                points="   653,155.999 649,155.999 649,141.999  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
              <polyline
                fill="none"
                points="   661,156 653,162 653,156  "
                stroke="#FFFFFF"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                strokeWidth="2"
              />
            </g>
            <g>
              <path d="M11.312,12.766c0.194,0.195,0.449,0.292,0.704,0.292c0.255,0,0.51-0.097,0.704-0.292c0.389-0.389,0.389-1.02,0-1.409   L4.755,3.384c-0.389-0.389-1.019-0.389-1.408,0s-0.389,1.02,0,1.409L11.312,12.766z" />
              <path d="M17.407,16.048L28.652,4.793c0.389-0.389,0.389-1.02,0-1.409c-0.389-0.389-1.019-0.561-1.408-0.171L15.296,15   c0,0-0.296,0-0.296,0s0,0.345,0,0.345L3.2,27.303c-0.389,0.389-0.315,1.02,0.073,1.409c0.194,0.195,0.486,0.292,0.741,0.292   s0.528-0.097,0.722-0.292L15.99,17.458l11.249,11.255c0.194,0.195,0.452,0.292,0.706,0.292s0.511-0.097,0.705-0.292   c0.389-0.389,0.39-1.02,0.001-1.409L17.407,16.048z" />
            </g>
          </svg>
          <div className={mobileMenu}>
            <NavLink className={cl.mobile_link} to="/">
              Home
            </NavLink>
            <NavLink className={cl.mobile_link} to="/about">
              About
            </NavLink>
            
            <NavLink className={cl.mobile_link} to="/products">
              Products
            </NavLink>
            <NavLink className={cl.mobile_link} to="/contacts">
              Contacts
            </NavLink>
            <NavLink className={cl.mobile_link} to="/policy">
              Policy
            </NavLink>
            <NavLink
              className={(headerData) =>
                headerData.isActive
                  ? cl.header_link_active_cart
                  : cl.header_link_cart
              }
              to="/cart"
            >
              <div className={cl.cart_items}>
                <img src={basket} alt="call" width="25px" height="25px" />

                <p className={cl.cart_items_number}>{props.cartItems.length}</p>
              </div>
            </NavLink>
          </div>
        </div>
        <svg
          onClick={onMenuClick}
          className={mobileMenuIcon}
          height="30px"
          viewBox="0 0 512 512"
          fill="white"
        >
          <title />
          <g data-name="1" id="_1">
            <path d="M441.13,166.52h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            <path d="M441.13,279.72h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
            <path d="M441.13,392.92h-372a15,15,0,1,1,0-30h372a15,15,0,0,1,0,30Z" />
          </g>
        </svg>
        <div className={cl.rightSide_line}>
          <a href="tel:123-456-7890">
            <img src={call} alt="call" width="25px" height="25px" />
          </a>

          <NavLink
            className={(headerData) =>
              headerData.isActive
                ? cl.header_link_active_cart
                : cl.header_link_cart
            }
            to="/cart"
          >
            <div className={cl.cart_items}>
              <img src={basket} alt="call" width="25px" height="25px" />

              <p className={cl.cart_items_number}>{props.cartItems.length}</p>
            </div>
          </NavLink>
        </div>
      </div>
    </section>
  );
};

export default Header;
